// extracted by mini-css-extract-plugin
export default {"select_User":"style_select_User__YrceP","title_ApprovalRequest":"style_title_ApprovalRequest__qbfs8","btn_addPage":"style_btn_addPage__aYka-","formItem":"style_formItem__tjxc2"};